/**
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export default {
  mode: 'light',
  common: {
    black: '#000',
    white: '#fff',
  },
  primary: {
    100: '#bae7ff',
    200: '#91d5ff',
    400: '#40a9ff',
    700: '#0050b3',
    900: '#002766',
    lighter: '#e6f7ff',
    light: '#69c0ff',
    main: '#1890ff',
    dark: '#096dd9',
    darker: '#003a8c',
    contrastText: '#fff',
  },
  secondary: {
    100: '#f5f5f5',
    200: '#f0f0f0',
    400: '#bfbfbf',
    600: '#595959',
    800: '#141414',
    lighter: '#f5f5f5',
    light: '#d9d9d9',
    main: '#8c8c8c',
    dark: '#262626',
    darker: '#000000',
    A100: '#ffffff',
    A200: '#434343',
    A300: '#1f1f1f',
    contrastText: '#ffffff',
  },
  error: {
    lighter: '#fff1f0',
    light: '#ffa39e',
    main: '#ff4d4f',
    dark: '#a8071a',
    darker: '#5c0011',
    contrastText: '#fff',
  },
  warning: {
    lighter: '#fffbe6',
    light: '#ffd666',
    main: '#faad14',
    dark: '#ad6800',
    darker: '#613400',
    contrastText: '#f5f5f5',
  },
  info: {
    lighter: '#e6fffb',
    light: '#5cdbd3',
    main: '#13c2c2',
    dark: '#006d75',
    darker: '#002329',
    contrastText: '#fff',
  },
  success: {
    lighter: '#f6ffed',
    light: '#95de64',
    main: '#52c41a',
    dark: '#237804',
    darker: '#092b00',
    contrastText: '#fff',
  },
  grey: {
    0: '#ffffff',
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#f0f0f0',
    300: '#d9d9d9',
    400: '#bfbfbf',
    500: '#8c8c8c',
    600: '#595959',
    700: '#262626',
    800: '#141414',
    900: '#000000',
    A50: '#fafafb',
    A100: '#fafafa',
    A200: '#bfbfbf',
    A400: '#434343',
    A700: '#1f1f1f',
    A800: '#e6ebf1',
  },
  text: {
    primary: '#343434',
    secondary: '#858585',
    disabled: '#bfbfbf',
  },
  action: {
    disabled: '#d9d9d9',
    active: 'rgba(0, 0, 0, 0.54)',
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12,
  },
  divider: '#f0f0f0',
  background: {
    demo: '#1414460d',
    paper: '#ffffff',
    default: '#ffffff',
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
};
